import {IonButton} from '@ionic/react';
import React, {useEffect, useId, useState} from 'react';

const COLLAPSE_THRESHOLD = 140;

interface ExpandableMessageTextProps {
    text: string;
    label: string;
}

const ExpandableMessageText: React.FC<ExpandableMessageTextProps> = ({text, label}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const contentId = useId();
    const canCollapse = text.length > COLLAPSE_THRESHOLD;

    useEffect(() => setIsExpanded(false), [text]);

    return (
        <div className="asterisk-expandable-text">
            <div
                id={contentId}
                className={canCollapse && !isExpanded ? 'asterisk-text-clamped' : ''}
                aria-label={label}
            >
                {text}
            </div>
            {canCollapse && (
                <IonButton
                    fill="clear"
                    size="small"
                    className="asterisk-expand-button"
                    aria-expanded={isExpanded}
                    aria-controls={contentId}
                    onClick={() => setIsExpanded((current) => !current)}
                >
                    {isExpanded ? 'Minder tonen' : 'Alles lezen'}
                </IonButton>
            )}
        </div>
    );
};

export default ExpandableMessageText;
